import { render } from "./ColourCard.vue?vue&type=template&id=52cdd097&scoped=true"
import script from "./ColourCard.vue?vue&type=script&lang=js"
export * from "./ColourCard.vue?vue&type=script&lang=js"

import "./ColourCard.vue?vue&type=style&index=0&id=52cdd097&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cdd097"]])

export default __exports__